"use strict";

function e(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var t = e({
  name: "persian_fa",
  months: [["فروردین", "فر"], ["اردیبهشت", "ار"], ["خرداد", "خرد"], ["تیر", "تیر"], ["مرداد", "مر"], ["شهریور", "شه"], ["مهر", "مه"], ["آبان", "آبا"], ["آذر", "آذ"], ["دی", "دی"], ["بهمن", "بهم"], ["اسفند", "اسف"]],
  weekDays: [["شنبه", "شن"], ["یکشنبه", "یک"], ["دوشنبه", "دو"], ["سه‌شنبه", "سه"], ["چهارشنبه", "چهار"], ["پنجشنبه", "پنج"], ["جمعه", "جم"]],
  digits: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
  meridiems: [["قبل از ظهر", "ق.ظ"], ["بعد از ظهر", "ب.ظ"]]
});
module.exports = t;